import { Component, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { DownloadFilesService } from '../../services/download-files.service';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css']
})
export class PreviewComponent implements AfterViewInit {

  private readonly PDF_PATH = 'assets/pdfs/breakers-preview-40.pdf';
  private readonly PDF_NAME = 'Breakers - A Queda das Chamas (prévia 40 páginas).pdf';

  innerWidth = window.innerWidth;

  constructor(
    private el: ElementRef,
    private downloadService: DownloadFilesService,
    private router: Router
  ) {}

  @HostListener('window:resize')
  onResize(): void {
    this.innerWidth = window.innerWidth;
  }

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const animatedEls: NodeListOf<Element> = this.el.nativeElement.querySelectorAll('.anim');
    animatedEls.forEach((el: Element) => observer.observe(el));
  }

  onReadNow(): void {
    this.router.navigate(['/preview']);
  }

  onDownload(): void {
    this.downloadService.downloadFile(this.PDF_PATH, this.PDF_NAME);
  }
}
